
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/austin-rsvp",
      function () {
        return require("private-next-pages/austin-rsvp.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/austin-rsvp"])
      });
    }
  